<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsTextField v-if="data.e_invoice_id != ''" :label="'E-invoice ID'" v-model="data.e_invoice_id" :readonly="true"></NevsTextField>
                <NevsTextField :error="validation.number" :label="$LANG.Get('fields.number')" v-model="data.number"></NevsTextField>
                <NevsDateField :error="validation.date_of_issue" :label="$LANG.Get('fields.dateOfIssue')" v-model="data.date_of_issue"></NevsDateField>
                <NevsTextField :label="$LANG.Get('fields.supplierName')" v-model="data.supplier_name"></NevsTextField>
                <NevsTextField :label="$LANG.Get('fields.supplierVatId')" v-model="data.supplier_vat_id"></NevsTextField>
                <NevsSelect :label="$LANG.Get('fields.currency')" v-model="data.currency" :ajax="'select/currencies'" :nullable="true"></NevsSelect>
                <NevsTextField :label="$LANG.Get('fields.shortDescription')" v-model="data.short_description"></NevsTextField>
                <NevsTextArea :label="$LANG.Get('fields.description')" v-model="data.description"></NevsTextArea>
                <NevsNumberField :error="validation.amount" :label="$LANG.Get('fields.amount')" v-model="data.amount"></NevsNumberField>
                <NevsUpload :label="$LANG.Get('fields.fileUpload')" v-model="data.file_upload"></NevsUpload>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-times"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="saveClick()">
                    <i class="fa-solid fa-floppy-disk"></i>
                    {{ $LANG.Get('buttons.save') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsUpload from "@/components/nevs/NevsUpload.vue";

export default {
    name: "ModalIncomingInvoice",
    components: {NevsUpload, NevsNumberField, NevsTextArea, NevsSelect, NevsDateField, NevsTextField, NevsButton},
    data() {
        return {
            data: {
                number: '',
                date_of_issue: null,
                short_description: '',
                description: '',
                amount: 0,
                file_upload: {name: '', link: '', id: 0},
                e_invoice_id: '',
                supplier_name: '',
                supplier_vat_id: '',
                currency: null
            },
            validation: {
                number: '',
                date_of_issue: '',
                amount: ''
            },
            loaded: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        incomingInvoiceId: {
            type: Number,
            default: null,
        }
    },
    emits: ['done'],
    watch: {
        'show'() {
            this.loaded = false;
            this.data = {
                number: '',
                date_of_issue: null,
                short_description: '',
                description: '',
                amount: 0,
                file_upload: {name: '', link: '', id: 0},
                e_invoice_id: '',
                supplier_name: '',
                supplier_vat_id: '',
                currency: null
            };
            this.validation = {
                number: '',
                date_of_issue: '',
                amount: ''
            };
            if (this.show && this.incomingInvoiceId != null) {
                let vm = this;
                this.$API.APICall('get', 'incoming-invoices/' + this.incomingInvoiceId, {}, (data, success) => {
                    if (success) {
                        vm.data.number = data.incoming_invoice.number;
                        vm.data.date_of_issue = data.incoming_invoice.date_of_issue;
                        vm.data.short_description = data.incoming_invoice.short_description;
                        vm.data.description = data.incoming_invoice.description;
                        vm.data.amount = data.incoming_invoice.amount;
                        vm.data.file_upload = data.incoming_invoice.file_upload || {name: '', link: '', id: 0};
                        vm.data.e_invoice_id = data.incoming_invoice.e_invoice_id;
                        vm.data.supplier_name = data.incoming_invoice.supplier_name;
                        vm.data.supplier_vat_id = data.incoming_invoice.supplier_vat_id;
                        vm.data.currency = data.incoming_invoice.currency;
                        vm.$nextTick(() => {
                            vm.loaded = true;
                        });
                    }
                });
            } else if (this.show) {
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            let valid = true;

            if (this.data.number === '') {
                valid = false;
                this.validation.number = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.number = '';
            }

            if (this.data.date_of_issue === null) {
                valid = false;
                this.validation.date_of_issue = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.date_of_issue = '';
            }

            if (this.data.amount === 0 || this.data.amount === null) {
                valid = false;
                this.validation.amount = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.amount = '';
            }

            if (valid) {
                let vm = this;
                if (this.incomingInvoiceId != null) {
                    this.$API.APICall('put', 'incoming-invoices/' + this.incomingInvoiceId, this.data, (data, success) => {
                        if (success) {
                            vm.$emit('done', true);
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    });
                } else {
                    this.$API.APICall('post', 'incoming-invoices', this.data, (data, success) => {
                        if (success) {
                            vm.$emit('done', true);
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.popup-form {
    padding: 10px;
}
</style>
